<template>
    <div class="modal-template" tabindex="-1" role="dialog" v-show="show">
            <div class="modal-background" @click="close">
                <div class="modal-container" @click.stop>
                    <div class="modal-close" @click="close">Close</div>
                    <slot></slot>
                </div>
            </div>
        </div>
</template>

<script>
    export default {
        name: "Modal",

        props: {
            show: {
                type: Boolean,
                default: false
            }
        },

        methods: {
            close() {
                this.$emit('close');
            }
        },

        watch: {
            show: function(current, old) {

                if(current) {
                    document.body.classList.add("modal-open");
                } else {
                    document.body.classList.remove("modal-open");
                }

            }
        }
    }
</script>
